import React from 'react';
import '../Styles/Input.css';

function Input({ type, placeholder, value, onChange, style, ...props }) {
  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className='login-input'
      style={style}
      {...props}
    />
  );
}

export default Input;
